export default {
  parts: ['container', 'segment', 'legend', 'legendItem', 'legendDot'],
  baseStyle: {
    container: {
      w: '100%',
      h: '30px', // lub inna stała wysokość
      align: 'center',
      bgColor: 'white',
      borderRadius: 'full',
      p: 1,
    },
    segment: {
      h: 'full',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'default',
      borderRadius: 'full',
      position: 'relative',
      px: 2,
      transition: 'filter 0.15s',
      fontWeight: 'medium',
      _hover: {
        filter: 'brightness(0.92)',
        zIndex: 99,
      },
    },
    legend: {
      mt: 1,
      w: '100%',
      justifyContent: 'flex-start',
      gap: 4,
    },
    legendItem: {
      alignItems: 'center',
    },
    legendDot: {
      w: '8px',
      h: '8px',
      borderRadius: 'full',
      mr: 1,
      flexShrink: 0,
    },
    label: {
      fontSize: 'xs',
      noOfLines: 1,
    },
  },
};
